import React from 'react';
import ImageDropzone from '../ImageDropzone';

const Req = () => <span style={{ color: '#e53e3e', marginLeft: '3px', fontWeight: '700' }}>*</span>;

const ProductModal = ({
    editItem,
    modalImageUrl,
    setModalImageUrl,
    modalBannerImageUrl,
    setModalBannerImageUrl,
    modalSpecs,
    addSpecRow,
    updateSpecRow,
    removeSpecRow,
    onSave,
    onClose
}) => {
    return (
        <div className="admin-modal-overlay" onClick={onClose}>
            <div className="admin-modal-card" onClick={(e) => e.stopPropagation()}>
                <div className="admin-modal-header">
                    <h3>{editItem ? 'Edit Product' : 'Add New Product'}</h3>
                    <button className="close-btn" onClick={onClose}>✕</button>
                </div>
                <form onSubmit={onSave} className="admin-modal-body">
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                        <div>
                            <label className="admin-label">Product Title<Req /></label>
                            <input type="text" name="title" defaultValue={editItem?.title || ''} className="admin-input" required />
                        </div>
                        <div>
                            <label className="admin-label">Category<Req /></label>
                            <input type="text" name="category" defaultValue={editItem?.category} className="admin-input" required />
                        </div>
                    </div>

                    <div className="m-t15">
                        <label className="admin-label">Slug <span style={{ fontWeight: '400', color: '#888', fontSize: '12px' }}>(URL identifier — e.g. acp-front-elevation)</span></label>
                        <input
                            type="text"
                            name="slug"
                            defaultValue={editItem?.slug || ''}
                            className="admin-input"
                            placeholder="acp-front-elevation (auto-generated from title if left empty)"
                        />
                    </div>

                    {/* DRAG & DROP MAIN IMAGE UPLOADER */}
                    <div className="m-t20">
                        <ImageDropzone
                            label="Product Main Featured Image"
                            value={modalImageUrl}
                            onChange={setModalImageUrl}
                            fallback="/images/products/acp_cladding.jpg"
                        />
                    </div>

                    {/* DRAG & DROP BANNER IMAGE UPLOADER */}
                    <div className="m-t15">
                        <ImageDropzone
                            label="Product Banner Image (Top Header Background)"
                            value={modalBannerImageUrl}
                            onChange={setModalBannerImageUrl}
                            fallback="/images/banner/6.jpg"
                        />
                    </div>

                    <div className="m-t15">
                        <label className="admin-label">Short Description<Req /></label>
                        <input type="text" name="shortDesc" defaultValue={editItem?.shortDesc || ''} className="admin-input" required />
                    </div>
                    <div className="m-t15">
                        <label className="admin-label">Full Description<Req /></label>
                        <textarea name="fullDesc" defaultValue={editItem?.fullDesc || ''} className="admin-textarea" rows="3" required />
                    </div>
                    <div className="m-t15">
                        <label className="admin-label">Key Features (One feature per line)</label>
                        <textarea
                            name="features"
                            defaultValue={(() => {
                                if (!editItem?.features) return '';
                                if (Array.isArray(editItem.features)) return editItem.features.join('\n');
                                if (typeof editItem.features === 'string') {
                                    try {
                                        const parsed = JSON.parse(editItem.features);
                                        if (Array.isArray(parsed)) return parsed.join('\n');
                                        return editItem.features;
                                    } catch (e) {
                                        return editItem.features;
                                    }
                                }
                                return '';
                            })()}
                            className="admin-textarea"
                            rows="3"
                        />
                    </div>

                    {/* INTERACTIVE TECHNICAL SPECIFICATIONS EDITOR WITH + ADD VALUE BUTTON */}
                    <div className="m-t20" style={{ backgroundColor: '#f8fafc', padding: '16px', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
                            <label className="admin-label" style={{ margin: 0, fontWeight: '800', fontSize: '15px', color: '#1e293b' }}>
                                <i className="fa fa-list-alt m-r5" style={{ color: '#f03a02' }} /> Technical Specifications
                            </label>
                            <button
                                type="button"
                                onClick={addSpecRow}
                                style={{
                                    backgroundColor: '#f03a02',
                                    color: '#ffffff',
                                    border: 'none',
                                    padding: '7px 15px',
                                    borderRadius: '6px',
                                    fontWeight: '700',
                                    fontSize: '13px',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    boxShadow: '0 2px 8px rgba(240, 58, 2, 0.25)'
                                }}
                            >
                                <i className="fa fa-plus-circle" />
                                <span>Add Value</span>
                            </button>
                        </div>

                        {modalSpecs.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '15px 10px', border: '2px dashed #cbd5e1', borderRadius: '8px', backgroundColor: '#ffffff' }}>
                                <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>
                                    No technical specifications added yet. Click <strong>"+ Add Value"</strong> to add name and value input fields below.
                                </p>
                            </div>
                        ) : (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {modalSpecs.map((spec, sIdx) => (
                                    <div key={sIdx} style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr 40px', gap: '10px', alignItems: 'center' }}>
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="Specification Name (e.g. Panel Thickness)"
                                                value={spec.key}
                                                onChange={(e) => updateSpecRow(sIdx, 'key', e.target.value)}
                                                className="admin-input"
                                                style={{ margin: 0, fontSize: '13.5px', fontWeight: '700', color: '#0f172a' }}
                                            />
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="Value (e.g. 3mm, 4mm, 6mm)"
                                                value={spec.value}
                                                onChange={(e) => updateSpecRow(sIdx, 'value', e.target.value)}
                                                className="admin-input"
                                                style={{ margin: 0, fontSize: '13.5px' }}
                                            />
                                        </div>
                                        <div>
                                            <button
                                                type="button"
                                                onClick={() => removeSpecRow(sIdx)}
                                                style={{
                                                    backgroundColor: '#fee2e2',
                                                    color: '#dc2626',
                                                    border: '1px solid #fca5a5',
                                                    borderRadius: '6px',
                                                    width: '38px',
                                                    height: '38px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer'
                                                }}
                                                title="Delete specification row"
                                            >
                                                <i className="fa fa-trash" />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="admin-modal-footer m-t20">
                        <button type="button" className="admin-btn admin-btn-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="admin-btn admin-btn-primary">Save Product</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ProductModal;
